import React, { useState} from "react";
import { connect } from "react-redux";
import { createNewItem } from "../../redux/actions/machineActions.js";
import {
  Badge,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Col,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  Table,
  UncontrolledDropdown,
  Label,
  FormGroup,
  Form,
  Input,
  Button,
  CustomInput
} from "reactstrap";

const CreateMachine = ({createNewItem}) => {
  const [item, setItem] = useState({
    label: '',
    attributes: [
      {
        name: '',
        value: ''
      }
    ],
    notes: [],
    category: ''
  })

  const changeAttribute = (e, index) => {
    let attributes = item.attributes;
    attributes[index][e.target.name] = e.target.value

    setItem({...item, attributes})
  }
  const addAttribute = () => {
    let attributes = item.attributes;
    attributes.push({
      name: '',
      value: ''
    })
    setItem({...item, attributes})
  }

  const submitItem = () => {
    createNewItem(item);
    setItem({
      label: '',
      attributes: [
        {
          name: '',
          value: ''
        }
      ],
      notes: [],
      category: ''
    })
  }

  return (
      <Container fluid className="p-0">
        <h1 className="h3 mb-3">Create Machine</h1>
        <Row>
          <Col xl="12">
            <Card>
                <CardHeader>
                  <div className="card-actions float-right">
                  </div>
                  <CardTitle tag="h5" className="mb-0">
                    Add attributes to build data set
                  </CardTitle>
                </CardHeader>
                <CardBody>
                  <tr>
                    <th>Machine Name:</th>
                    <td>
                      <Input
                        name='label'
                        value={item.label}
                        onChange={(e) => setItem({...item, label: e.target.value})}
                      />
                    </td>
                  </tr>
                  <tr>
                    <th>Category:</th>
                    <td>
                      <Input
                        name='category'
                        value={item.category}
                        onChange={(e) => setItem({...item, category: e.target.value})}
                      />
                    </td>
                  </tr>
                  <Table size="sm" className="my-2">
                      <th>Attribute Name</th>
                      <th>Value</th>
                    <tbody>
                      {(item.attributes.map((x, index)=>
                        <tr key={index}>
                          <td>
                            <Input
                              name='name'
                              value={x.name}
                              onChange={(e) => changeAttribute(e, index)}
                            />
                          </td>
                          <td>
                            <Input
                              name='value'
                              value={x.value}
                              onChange={(e) => changeAttribute(e, index)}
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                  <Button onClick={() => addAttribute()}>Add Attribute</Button>
                  <hr />
                  <Col lg="12">
                  </Col>
                </CardBody>
                <Button onClick={() => submitItem(item)}>Create Machine</Button>
            </Card>
          </Col>
        </Row>

      </Container>
    );
}
const mapStateToProps = state => ({
  machine: state.machine
})

export default connect(mapStateToProps, {createNewItem})(CreateMachine);
